/*
<summary>
   This file is used to provide initial values or state to the AddProcessForm.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { ITagReassignVM } from '../../models/response/ITagReassignResponse';
const initialProcessState: ITagReassignVM = {
  ProcessName: '',
  Id: 0,
  TrayId: '',
  TagId: ''
};

export default initialProcessState;
